/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    const headerSelector = '.header';
    const headerStickyClass = 'header-sticky';
    const headerElement = document.querySelector(headerSelector);
  
    const setStickyHeader = () => {
      const top = window.scrollY || document.documentElement.scrollTop;
      body.classList.toggle(headerStickyClass, top > headerElement.offsetHeight / 2);
    };
  
    const init = () => {
      if (!headerElement) {
        return; // Return early if the header element is not found
      }
  
      // Sticky header
      setStickyHeader();
      window.addEventListener('scroll', setStickyHeader);
    };
  
    init();
  }
  